import userApi from '../api/user-api';

const add = async (user) => {
    const resp = await userApi.register(user);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const edit = async (user) => {
    const resp = await userApi.edit(user);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const remove = async (user) => {
    const resp = await userApi.remove(user);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const search = async (condition, pagination) => {
	try {
		const result = await userApi.search(condition, pagination);
		return { list: result.list, pagination: result.paginable };
	} catch (err) {
		console.error(err);
		throw err;
	}
};

const getById = async (payload) => {
    const resp = await userApi.getById(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const resetPassword = async (payload) => {
    const resp = await userApi.resetPassword(payload);
    if (resp.status !== "SUCCESS") {
        throw resp.responseMsgTh;
    }
    return resp;
}

const userService = {
    add,
    edit,
    remove,
    search,
    getById,
    resetPassword
};

export default userService;